module.exports = __webpack_public_path__ + "static/media/background.38ef8dcf.png";